import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../api/client";

// LOG TẠM 16/10: xem log chấm vào / chấm ra theo ngày (trang ẩn /checkin-debug-log). Gỡ cùng log tạm.
export const DEBUG_LOG_PER_PAGE = 50;

async function fetchCheckinDebugLogs(filters) {
  const options = { limit: DEBUG_LOG_PER_PAGE, page: filters.page || 1 };
  if (filters.date) options.date = filters.date;
  if (filters.search) options.search = filters.search;
  if (filters.tag) options.tag = filters.tag;
  if (filters.errorsOnly) options.errorsOnly = "1";
  if (filters.hideElig) options.hideElig = "1";

  const query = new URLSearchParams(options).toString();
  const data = await clientAPI("get", `/checkinV2/debug-logs?${query}`);
  if (!data || typeof data !== "object" || !Array.isArray(data.items)) {
    throw new Error(typeof data === "string" ? data : "Không tải được log");
  }
  return data;
}

export function useCheckinDebugLogs(filters) {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: ["checkinDebugLogs", filters],
    queryFn: () => fetchCheckinDebugLogs(filters),
    refetchOnWindowFocus: false,
    placeholderData: (prev) => prev,
    retry: false,
  });

  const total = data?.pagination?.total || 0;
  const page = data?.pagination?.page || 1;
  return {
    data,
    items: data?.items || [],
    summary: data?.summary,
    dates: data?.dates || [],
    date: data?.date,
    total,
    totalPages: Math.ceil(total / DEBUG_LOG_PER_PAGE),
    startEntry: total ? (page - 1) * DEBUG_LOG_PER_PAGE + 1 : 0,
    endEntry: Math.min(page * DEBUG_LOG_PER_PAGE, total),
    refetch,
    isLoading,
    isFetching,
    error,
  };
}
